import type { IconSvgObject } from './types';

const FolderAttachmentIcon: IconSvgObject = [
  ["path", { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V12M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H13.0179", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 15.4615V17.9231C21 19.6224 19.6569 21 18 21C16.3431 21 15 19.6224 15 17.9231V14.5385C15 13.6888 15.6716 13 16.5 13C17.3284 13 18 13.6888 18 14.5385V17.9231", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderAttachmentIcon;
